import React from 'react';
import { Application } from '../../../models';
import { ArticleIcon } from '../../icons';
import EssayForm from './EssayForm';

interface SixthStepProps {
  application?: Application;
  isReadOnly?: boolean;
}

export default function SixthStep({
  application = null,
  isReadOnly = false,
}: SixthStepProps) {
  return (
    <div className="p-6 lg:py-20 lg:px-32 flex flex-col">
      <div className="w-20 h-20 rounded-full bg-[#B6EDFF99]/60 border border-[#B6EDFF99]/80 flex">
        <ArticleIcon className="h-12 w-12 m-auto text-cyan" />
      </div>
      <div className="mt-8">
        <h2 className="font-bold text-5xl text-neutral-600">Essays</h2>
      </div>
      <div className="mt-8 flex flex-col">
        <EssayForm application={application} isReadOnly={isReadOnly} />
      </div>
    </div>
  );
}
